"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lineHeight = exports.fontWeights = exports.fontSizes = void 0;
var fontSizes = exports.fontSizes = {
  z100: "1.2rem",
  z200: "1.4rem",
  z300: "1.6rem",
  z400: "1.8rem",
  z500: "2rem",
  z600: "2.4rem",
  z700: "3rem",
  z800: "3.6rem",
  z900: "4.4rem",
  z1000: "5.4rem"
};
var fontWeights = exports.fontWeights = {
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500 //to be added to storybook
};
var lineHeight = exports.lineHeight = {
  regular: 1.2,
  medium: 1.5
};